module.exports = __webpack_public_path__ + "static/media/hybrid_multi_cloud.5ad9bac6.svg";